/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterBSmall = createReactComponent("outline", "letter-b-small", "IconLetterBSmall", [["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-0" }]]);

export { IconLetterBSmall as default };
//# sourceMappingURL=IconLetterBSmall.mjs.map
